import {
   AfterViewInit, Component, EventEmitter, HostListener, Input, OnInit, Output
} from '@angular/core';
import {IdexService} from '../../../idex.service';
import {DeleteDialogComponent} from '../../delete-dialog/delete-dialog.component';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {Toast} from '../../../shared/toast/toast';
import {Router} from '@angular/router';
import { TaskAttribute } from '../../create-task/create-task.type';

declare let $: any;

@Component({
   selector: 'app-thumbnail',
   templateUrl: './thumbnail.component.html',
   styleUrls: ['./thumbnail.component.css']
})
export class ThumbnailComponent implements OnInit, AfterViewInit {
   @Input() item: any;
   @Input() mimType: any;
   @Input() typeName: any;
   @Input() currentIndex: any;
   @Input() isDocList: any;
   @Input() selectAll: any;
   @Input() selectButton: any;
   @Input() totalPages: any;
   @Input() flagRotate: any;
   @Input() thumbnailSelected: any;
   @Input() index: any;
   @Input() isSelected: any;
   @Input() selectDelItems: any;
   @Input() maxIndex: any;
   @Input() dataWidthHeight: any;
   @Input() sendWidthHeight: any;
   @Input() sendWidthHeightAll: any;
   @Input() dataWidthHeightAll: any;
   @Input() clickButton: any;
   @Input() taskId: any;
   @Input() createTaskComp: any;
   @Input() createTemplateComp: any;
   @Input() createTaskSignOffComp: any;
   @Input() createTemplateSignOffComp: any;
   @Input() flagCheckSelect: any;
   @Input() checkboxAll: any;
   @Input() selectedTab: any;
   @Input() taskAttribute: TaskAttribute;
   @Input() stepper: any;
   @Input() uploadComp: any;
   @Input() loadedBypage: any;
   @Input() isCompleteTask: any;
   @Input() signDocComp;
   @Input() mode;
   @Output() flagCheckSelectChange = new EventEmitter<any>();
   @Output() flagCheckLoadDataChange = new EventEmitter<any>();
   @Output() oncheckSelect = new EventEmitter<any>();
   @Output() selectButtonChange = new EventEmitter<any>();
   @Output() saveRotate = new EventEmitter<any>();
   @Output() onrotateByPage = new EventEmitter<any>();
   @Output() onclickThumbnail = new EventEmitter<any>();
   selectedItems: any[] = [];
   activeItem: any;
   info: any;
   checkloaded: any = [];
   shiftPressed = false;
   pageRotate = -1;
   scaleRotate = -1;
   flagpage = true;
   canDrag = true;
   public isDeleteDocument = false;
   public thumbnailSelectedDel = [];
   public indexSelect;
   public imgUrl: any;
   public sumPage: any = 0;
   public pageNum: any[];
   public checkSpinner = true;
   public appendUrl;
   private dpi = 20;
   public check: any;
   @Output() maxIndexChange = new EventEmitter<any>();
   dWidth: any;
   dHeight: any;
   constructor(private service: IdexService,
               private toast: Toast,
               private dialog: MatDialog,
               private router: Router) {
   }

   ngOnInit() {
      if (this.dataWidthHeight) {
         this.dWidth = this.dataWidthHeight.width;
         this.dHeight = this.dataWidthHeight.height;
      }
      if (this.item.pageNo > this.sumPage) {
         this.sumPage = this.item.pageNo;
      }
      this.imgUrl = this.service.url + '/document/' + this.item.docId + '/';
      if (this.taskId) {
         this.appendUrl = '/' + this.dpi + '?taskId=' + this.taskId + '&token=' + this.service.user.token + '&lastmodify=' + Date.now();
      } else {
         this.appendUrl = '/' + this.dpi + '?token=' + this.service.user.token + '&lastmodify=' + Date.now();
      }
      this.maxIndex = -1;
   }

   ngAfterViewInit() {
      for (let i = 0; i < this.totalPages; i++) {
         $('.thumbnail_' + i).removeClass('active-thumbnails-height');
         $('.thumbnail_' + i).removeClass('active-thumbnails-width');
      }
   }

   checkSpin() {
      if (this.imgUrl != null) {
         this.checkSpinner = false;
      } else {
         this.checkSpinner = true;
      }
   }

   /**
    *
    * @detail : check button thumbnails when click checkbox by page
    */

   onClickButton(event: any) {
      this.thumbnailSelected[this.index].isSelected = event.checked;
      if (event.checked) {
         this.selectDelItems[this.index] = this.index + 1;

         this.oncheckSelect.emit({'select': this.index, 'status': true});
         if (this.dataWidthHeight?.width < this.dataWidthHeight?.height && !this.flagRotate) {
            $('.thumbnail_' + this.index).addClass('active-thumbnails-height');
            $('.thumbnail_' + this.index).removeClass('set-height');
         } else if (this.dataWidthHeight?.width > this.dataWidthHeight?.height) {
            $('.thumbnail_' + this.index).addClass('active-thumbnails-width');
            $('.thumbnail_' + this.index).removeClass('set-width');
         }
         if (this.sendWidthHeight?.width < this.sendWidthHeight?.height && this.flagRotate) {
            $('.thumbnail_' + this.index).addClass('active-thumbnails-height');
         } else if (this.sendWidthHeight?.width > this.sendWidthHeight?.height && this.flagRotate) {
            $('.thumbnail_' + this.index).addClass('active-thumbnails-width');
         }
         this.checkMaxPage(this.index + 1);

      } else {
         this.oncheckSelect.emit({'select': this.index, 'status': false});
         if (this.dataWidthHeight?.width < this.dataWidthHeight?.height && !this.flagRotate) {
            $('.thumbnail_' + this.index).removeClass('active-thumbnails-height');
            $('.thumbnail_' + this.index).addClass('set-height');
         } else if (this.dataWidthHeight?.width > this.dataWidthHeight?.height && !this.flagRotate) {
            $('.thumbnail_' + this.index).removeClass('active-thumbnails-width');
            $('.thumbnail_' + this.index).addClass('set-width');
         }
         if (this.sendWidthHeight?.width < this.sendWidthHeight?.height && this.flagRotate) {
            $('.thumbnail_' + this.index).removeClass('active-thumbnails-height');
            $('.thumbnail_' + this.index).removeClass('active-thumbnails-width');
         } else if (this.sendWidthHeight?.width > this.sendWidthHeight?.height && this.flagRotate) {
            $('.thumbnail_' + this.index).removeClass('active-thumbnails-width');
            $('.thumbnail_' + this.index).removeClass('active-thumbnails-height');
         }
         if (!this.checkSelectedButton(this.thumbnailSelected, this.totalPages)) { // case unselect all set maxIndex = -1
            this.maxIndex = -1;
            this.maxIndexChange.emit(this.maxIndex);
         } else {
            this.maxIndex = this.checkMaxPageSelected(this.thumbnailSelected, this.totalPages);
         }
      }
      if (this.selectButton) {
         this.selectButton = false;
      } else {
         if (this.checkSelectedAll(this.thumbnailSelected, this.totalPages)) {
            this.selectButton = true;
         } else {
            this.selectButton = false;
         }
      }
      this.selectButtonChange.emit(this.selectButton);
   }

   /**
    * @details check when have selected Button
    * @param item list check box data
    * @param totalPage;
    * @returns boolean if have just 1 selected return true
    * by Bestz
    */
   checkSelectedButton(item, totalPage) {
      for (let i = 0; i < totalPage; i++) {
         if (item[i].isSelected) {
            return true;
         }
      }
      return false;
   }

   /**
    *
    * @detail : check max page for thumbnail
    */
   checkMaxPageSelected(item, totalPage) {
      for (let j = totalPage - 1; j >= 0; j--) {
         if (item[j].isSelected) {
            return j + 1;
         }
      }
      return -1;
   }

   /**
    *
    * @detail : check button thumbnails when click all button
    */
   checkButtonAll(event: any) {
      for (let i = 0; i < this.totalPages; i++) {
         if (event.checked) {
            this.oncheckSelect.emit({'select': -1, 'status': true});
            if (this.dataWidthHeightAll[i].width < this.dataWidthHeightAll[i].height) {
               $('.thumbnail_' + i).addClass('active-thumbnails-height');
               $('.thumbnail_' + i).removeClass('set-height');
            } else if (this.dataWidthHeightAll[i].width > this.dataWidthHeightAll[i].height) {
               $('.thumbnail_' + i).addClass('active-thumbnails-width');
               $('.thumbnail_' + i).removeClass('set-width');
            }
         } else {
            this.oncheckSelect.emit({'select': -2, 'status': true});
            if (this.dataWidthHeightAll[i].width < this.dataWidthHeightAll[i].height) {
               $('.thumbnail_' + i).removeClass('active-thumbnails-height');
               $('.thumbnail_' + i).addClass('set-height');
            } else if (this.dataWidthHeightAll[i].width > this.dataWidthHeightAll[i].height) {
               $('.thumbnail_' + i).removeClass('active-thumbnails-width');
               $('.thumbnail_' + i).addClass('set-width');
            }
         }
         this.maxIndex = -1;
         this.maxIndexChange.emit(this.maxIndex);
      }
   }

   checkButtonAllRotate2(event: any, item: any) {
      for (let i = item; i < this.totalPages; i++) {
         if (this.sendWidthHeightAll.itemRotate[i].item.width < this.sendWidthHeightAll.itemRotate[i].item.height) {
            $('.thumbnail_' + i).addClass('active-thumbnails-height');
         } else if (this.sendWidthHeightAll.itemRotate[i].item.width > this.sendWidthHeightAll.itemRotate[i].item.height) {
            $('.thumbnail_' + i).addClass('active-thumbnails-width');
         }
      }
   }

   checkButtonAllRotate(event: any) {
      for (let i = 0; i < this.totalPages; i++) {
         if (event.checked) {
            this.oncheckSelect.emit({'select': -1, 'status': true});
            if (this.sendWidthHeightAll.itemRotate[i].item.width < this.sendWidthHeightAll.itemRotate[i].item.height) {
               $('.thumbnail_' + i).addClass('active-thumbnails-height');
            } else if (this.sendWidthHeightAll.itemRotate[i].item.width > this.sendWidthHeightAll.itemRotate[i].item.height) {
               $('.thumbnail_' + i).addClass('active-thumbnails-width');
            }
         } else {
            this.oncheckSelect.emit({'select': -2, 'status': true});
            if (this.sendWidthHeightAll.itemRotate[i].item.width < this.sendWidthHeightAll.itemRotate[i].item.height) {
               $('.thumbnail_' + i).removeClass('active-thumbnails-height');
               $('.thumbnail_' + i).removeClass('active-thumbnails-width');
            } else if (this.sendWidthHeightAll.itemRotate[i].item.width > this.sendWidthHeightAll.itemRotate[i].item.height) {
               $('.thumbnail_' + i).removeClass('active-thumbnails-width');
               $('.thumbnail_' + i).removeClass('active-thumbnails-height');
            }
         }
         this.maxIndex = -1;
         this.maxIndexChange.emit(this.maxIndex);
      }
   }

   /**
    *
    * @detail : When key down on keyboard 'A' button thumbnails will be selected all button
    * and when key down on keyboard 'D' button thumbnails will be unselected all button.
    */
   @HostListener('document:keydown', ['$event'])
   onKeyDown(e: KeyboardEvent) {
      if (e.shiftKey) {
         this.shiftPressed = true;
      } else if (e.key === 'a' && (e.ctrlKey || e.metaKey) && this.selectedTab === 0) {
         e.preventDefault();
         e.stopPropagation();
         for (let i = 0; i < this.totalPages; i++) {
            this.thumbnailSelected[i].isSelected = true;
         }
         this.selectButton = true;
         this.selectButtonChange.emit(this.selectButton);
         this.flagCheckSelect = true;
         this.flagCheckSelectChange.emit(this.flagCheckSelect);
      } else if (e.key === 'd' && (e.ctrlKey || e.metaKey)) {
         e.preventDefault();
         e.stopPropagation();
         for (let i = 0; i < this.totalPages; i++) {
            this.thumbnailSelected[i].isSelected = false;
         }
         this.selectButton = false;
         this.selectButtonChange.emit(this.selectButton);
         this.flagCheckSelect = false;
         this.flagCheckSelectChange.emit(this.flagCheckSelect);
      }
   }

   @HostListener('document:keyup', ['$event'])
   onKeyUp(e: KeyboardEvent) {
      if (e.shiftKey) {
         this.shiftPressed = false;
      }
   }

   /**
    *
    * @detail :  Check that all buttons are pressed
    */
   checkSelectedAll(item, totalPage) {
      for (let i = 0; i < totalPage; i++) {
         if (!item[i].isSelected) {
            return false;
         }
      }
      return true;
   }

   clickThumbnails($event) {
      this.onclickThumbnail.emit(this.item.pageNo);
   }

   /**
    *
    * @detail :  find max position select button
    */
   checkMaxSelect() {
      for (let i = this.totalPages - 1; i--;) {
         if (this.thumbnailSelected[i].isSelected) {
            return i + 1;
         }
      }
      return -1;
   }

   /**
    *
    * @detail : Check max page for thumbnails
    */
   checkMaxPage(index) {
      if (this.maxIndex <= index) {
         this.maxIndex = index;
      }
      this.maxIndexChange.emit(this.maxIndex);
   }

   getMaxPage() {
      return this.maxIndex;
   }

   onRotatePage(index) {
      this.onrotateByPage.emit(index);
   }

   /**
    *
    * @detail : show delete dialog for delete thumbnails
    */
   onClickDeleteThumbnail(index) {
      if (this.isDocList && this.currentIndex === 0 && this.totalPages <= 1) {
         this.createTaskComp.handleToastError('newTask.errorSelectDelete');
      } else if (this.typeName === 'startFlow' && this.currentIndex === 0 && this.totalPages <= 1) {
         this.createTaskComp.handleToastError('newTask.errorSelectDelete');
      } else {
         this.flagCheckLoadDataChange.emit();
         const dialogRef = this.dialog.open(DeleteDialogComponent, {
            disableClose: true,
            height: '110px',
            data: {
               index: index,
               selectButton: this.selectButton,
               service: this.service,
               createTaskSignOffComp: this.createTaskSignOffComp,
               taskId: this.taskId,
               toast: this.toast,
               signDocComp: this.signDocComp,
               router: this.router,
               totalPages: this.totalPages,
               thumbnailSelect: this.thumbnailSelected,
               createTaskComp: this.createTaskComp,
               createTemplateSignOffComp: this.createTemplateSignOffComp,
               createTemplateComp: this.createTemplateComp,
            }
         });

         dialogRef.afterClosed().subscribe(result => {
            if (result.response) {
               this.isDeleteDocument = false;
               this.flagCheckSelect = false;
               this.saveRotate.emit();
               this.scroll(1);
               this.flagCheckSelectChange.emit(this.flagCheckSelect);
               this.maxIndex = -1;

               this.createTaskComp.bindData(result, index);
            }
         });
      }
   }

   scroll(page) {
      page = page - 1;
      if (this.flagRotate) {
         const elmnt = document.getElementById('thumbnail1_' + page);
         if (elmnt) {
            elmnt.scrollIntoView({
               inline: 'nearest',
            });
         }
      }
      if (!this.flagRotate) {
         const elmnt = document.getElementById('thumbnail2_' + page);
         if (elmnt) {
            elmnt.scrollIntoView({
               inline: 'nearest',
            });
         }
      }
   }
}
